export default function auth({ next, store }) {
  if (!store.getters.isUser) {
    const page = window.location.pathname;
    return next({
      name: 'login',
      params: { fromPagina: page },
    });
  }
  return next();
}
